export const p = (text) => ({ type: 'p', text });
export const list = (items) => ({ type: 'list', items });
export const steps = (items) => ({ type: 'steps', items });
export const tip = (text, title = 'Praxis-Tipp') => ({ type: 'tip', title, text });
export const warn = (text, title = 'Achtung') => ({ type: 'warn', title, text });
export const table = (head, rows) => ({ type: 'table', head, rows });
export const faq = (items) => ({ type: 'faq', items });
export const section = (heading, ...blocks) => ({ heading, blocks });
